// extracted by mini-css-extract-plugin
module.exports = {"image":"image-module--image--3hN_2"};